<div matDialogTitle>Detaljer</div>
<mat-dialog-content>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>KALP överskott/underskott</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <spb-applicants [kalpylator]="kalpylator"
                      type="kalp-details"/>

    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Inkomster</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <spb-applicants [kalpylator]="kalpylator" type="income"/>

    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Kostnader</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <spb-applicants [kalpylator]="kalpylator" type="cost"/>

    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Lån</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <spb-loans [kalpylator]="kalpylator"/>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Boende</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <spb-properties [kalpylator]="kalpylator"/>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="outlined" matDialogClose>Stäng</button>
</mat-dialog-actions>
